import axios from "src/utils/axios";

export const getList = async ({ titleType }) => {
  const response = await axios.get(
    `/home?source=web&titletype=${titleType}&layout=list`
  );
  return response;
};

export const getGrid = async ({ titleType }) => {
  const response = await axios.get(
    `/homepage?source=web&titletype=${titleType}&type=genre&layout=grid`
  );
  return response;
};

export const getNextPage = async (url) => {
  const response = await axios.get(url);
  return response;
};

export const fetchWithURL = async (url) => {
  const response = await axios.get(url);
  return response;
};

export const filterGrid = async ({ titleType, url }) => {
  const response = await axios.get(
    `/homepage?source=web&titletype=${titleType}&type=genre&${url}`
  );
  return response;
};
